import { render, staticRenderFns } from "./purchasingMgVanCollapseContenty.vue?vue&type=template&id=3486b03b&scoped=true"
import script from "./purchasingMgVanCollapseContenty.vue?vue&type=script&lang=js"
export * from "./purchasingMgVanCollapseContenty.vue?vue&type=script&lang=js"
import style0 from "./purchasingMgVanCollapseContenty.vue?vue&type=style&index=0&id=3486b03b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486b03b",
  null
  
)

export default component.exports